import { Delete } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import React, { useEffect, useState } from "react";

import useService from "../../../../../hooks/useService";
import CustomIconButton from "../../../../ui library/components/buttons/CustomIconButton";
import AutoCompleteDropdown from "../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import { useUploadDocumentStore } from "../hooks/useUploadDocumentStore";

import CustomListBox from "./CustomListBox";

const BillListItem = ({ apptId, bill, initialServices, nextPage }) => {
  const administeredServiceRepository = useService("repositories/administered-service-repository");
  const { provider } = useUploadDocumentStore();

  const [data, setData] = useState(initialServices || []);
  const [showMore, setShowMore] = useState(false);
  const [nextPg, setNextPg] = useState(nextPage);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (nextPg) {
      setShowMore(true);
    } else {
      setShowMore(false);
    }
  }, [nextPg]);

  const fetchServices = async (search = "", newLimit = 25, offset = 0) => {
    if (!provider.id) {
      return;
    }

    const params = {
      providerId: provider.id,
      limit: newLimit,
      offset,
    };
    if (search) {
      params.search = search;
    }

    const fetchedData = await administeredServiceRepository.query(params);

    const mapped =
      fetchedData?.map((item) => ({
        id: item.id,
        label: [item.serviceCode, item.serviceName],
      })) || [];

    if (offset === 0) {
      setData(mapped);
    } else {
      setData((prev) => [...prev, ...mapped]);
    }

    const next = await administeredServiceRepository.getNextPage();
    setNextPg(next);
    setShowMore(!!next);
  };
  const fetchNextPage = () => {
    if (!nextPg) {
      return;
    }

    const url = new URL(nextPg);
    const newLimit = parseInt(url.searchParams.get("limit"));
    const newOffset = parseInt(url.searchParams.get("offset"));

    fetchServices(searchText, newLimit, newOffset);
  };
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      fetchServices(searchText, 0);
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [searchText, provider.id]);

  const handleShowMore = () => {
    fetchNextPage();
  };

  return (
    <div className="flex w-full flex-row">
      <div className="w-1/2 p-2">
        <AutoCompleteDropdown
          freeSolo
          label="Services"
          data={data}
          initValue={bill}
          onValueChange={(_, value) => {
            const serviceId = value?.id || "";
            const serviceInfo = value?.label || [];
            bill.updateServiceId(apptId, bill.id, serviceId, serviceInfo);
          }}
          onInputChange={(_, newInputValue, reason) => {
            if (reason === "input") {
              setSearchText(newInputValue);
            }
          }}
          getOptionLabel={(option) => {
            if (!option) {
              return "";
            }
            if (Array.isArray(option.label)) {
              return option.label.join(" - ");
            }
            if (option.service_id && option.service_info) {
              return `${option.service_info[0]} - ${option.service_info[1]}`;
            }
            return "";
          }}
          ListboxComponent={CustomListBox}
          ListboxProps={{
            showMore,
            setShowMore: handleShowMore,
          }}
        />
      </div>
      <div className="flex w-1/2 items-center gap-2 p-2">
        <TextField
          className="w-full"
          label="Procedure Bill Total"
          variant="outlined"
          value={bill.price}
          onChange={(e) => bill.updatePrice(apptId, bill.id, e.currentTarget.value)}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            endAdornment: bill.price ? (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => bill.updatePrice(apptId, bill.id, "")}>
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
        />
      </div>

      <div>
        <CustomIconButton
          classes="p-2"
          iconVisible={true}
          CustomIcon={<Delete className="text-red-500" />}
          handleOnClick={() => bill.deleteRow(apptId, bill.id)}
        />
      </div>
    </div>
  );
};

export default BillListItem;
